<template>
  <a-form
    ref="formRef"
    :model="formState"
    :rules="rules"
    :label-col="{
      span: 7,
    }"
    :wrapper-col="{
      span: 13,
    }"
  >
    <a-form-item ref="name" label="部门名" name="name">
      <a-input v-model:value="formState.name" />
    </a-form-item>
    <a-form-item ref="code" label="唯一编码" name="code">
      <a-input v-model:value="formState.code" placeholder="不能超过30个字符" />
    </a-form-item>
    <a-form-item
      ref="visitArea"
      label="所属区域"
      name="visitArea"
    >
      <a-select
        ref="select"
        v-model:value="formState.visitArea"
        :options="visitAreaOption"
        placeholder="点击选择所属区域"
      ></a-select>
    </a-form-item>
    <a-form-item
      ref="status"
      label="状态"
      name="status"
    >
      <a-select
        ref="select"
        v-model:value="formState.status"
        :options="departStatusOption"
        placeholder="点击选择状态"
      ></a-select>
    </a-form-item>
    <a-form-item
        ref="departType"
        label="部门类型"
        name="vs"
    >
      <a-select
          ref="select"
          v-model:value="formState.departType"
          :options="departTypeOption"
          placeholder="点击选择部门类型"
      ></a-select>
    </a-form-item>
    <a-form-item label="备注" name="remark">
      <a-input
        v-model:value="formState.remark"
        placeholder="不能超过80个文字"
      />
    </a-form-item>
    <a-form-item :wrapper-col="{ span: 14, offset: 4 }">
      <a-button type="primary" @click="onSubmit">提交</a-button>
      <a-button style="margin-left: 10px" @click="resetForm">重置</a-button>
    </a-form-item>
  </a-form>
</template>
<script setup>
  import { reactive, ref, toRaw, defineProps, defineEmits } from 'vue'
  import { message } from 'ant-design-vue'
  import { createDept, updateDept } from '@/api/system_manage/dept'

  const visitAreaOption = ref([
    {
      value: 1,
      label: '石化区'
    },
    {
      value: 2,
      label: '惠州港'
    },
    {
      value: 3,
      label: '石化区和惠州港'
    }
  ])

  const departStatusOption = ref([
    {
      value: 1,
      label: '启用'
    },
    {
      value: 0,
      label: '禁用'
    },
  ])

  const departTypeOption = ref([
    {
      value: 1,
      label: '园区企业'
    },
    {
      value: 2,
      label: '职能部门'
    },
    {
      value: 3,
      label: '长期服务商'
    },
    {
      value: 4,
      label: '短期服务商'
    },
  ])

  const props = defineProps({ isEdit: Boolean, editData: Object, data: Array })
  const emit = defineEmits(['submit'])
  const formRef = ref()

  const defaultFormState = props.isEdit
    ? {
        pid: props.editData?.pid || 0,
        departId: props.editData.depart_id,
        name: props.editData.name,
        code: props.editData.code,
        visitArea: props.editData.visit_area,
        remark: props.editData.remark,
        status: props.editData.status,
        departType: props.editData.depart_type,
      }
    : {
        pid: props.editData?.depart_id || 0,
        name: '',
        code: '',
        visitArea: 1,
        remark: '',
        status: 1,
        departType: 1,
      }
  const formState = reactive(defaultFormState)
  const rules = {
    name: [
      {
        required: true,
        message: '请输入部门名',
        trigger: 'change',
      },
      {
        min: 1,
        max: 30,
        message: '不能超过30个文字',
        trigger: 'blur',
      },
    ],
    code: [
      {
        required: true,
        message: '请输入唯一编码',
        trigger: 'change',
      },
      {
        min: 1,
        max: 30,
        message: '不能超过30个字符',
        trigger: 'blur',
      },
      {
        pattern: /^[0-9a-zA-Z:_]+$/,
        message: '仅限阿拉伯数字、英文字母',
        trigger: 'change',
      },
    ],
    visitArea: [
      {
        required: true,
        message: '请选择所属区域',
        trigger: 'blur',
      },
    ],
    status: [
      {
        required: true,
        message: '请选择状态',
        trigger: 'blur',
      },
    ],
    departType: [
      {
        required: true,
        message: '请选择部门类型',
        trigger: 'blur',
      },
    ],
  }
  async function handelCreate(data) {
    const ajaxFn = props.isEdit ? updateDept : createDept
    const messageText = props.isEdit ? '编辑' : '创建'
    const res = await ajaxFn(data)
    if (res.success) {
      message.success(messageText + '部门成功！')
      emit('submit')
    } else {
      message.warn(messageText + '部门错误：', res.message)
    }
  }
  function onSubmit() {
    formRef.value
      .validate()
      .then(() => {
        handelCreate(toRaw(formState))
      })
      .catch((error) => {
        console.log('创建部门错误：', error)
      })
  }
</script>
